import React from 'react';
import styled from 'styled-components';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, LineElement, PointElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, ChartDataLabels);

export function LineChart({ list }) {
  const data = {
    labels: list.map((item) => `${item.time}시`),
    datasets: [
      {
        label: '기온',
        data: list.map((item) => (item.temperature === '' ? null : item.temperature)),
        fill: false,
        borderColor: 'rgb(0, 187, 249)',
        borderWidth: 1,
        pointRadius: 3,
        pointBackgroundColor: 'rgb(0, 187, 249)',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: false,
        offset: true,
      },
      y: {
        display: false,
        ticks: {
          stepSize: 40,
          display: false,
        },
      },
    },
    layout: {
      padding: {
        top: 20,
      },
    },
    elements: {
      line: {
        tension: 0.1,
      },
    },
    plugins: {
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'end',
        offset: -2,
        color: '#252729',
        font: {
          weight: 'bold',
          size: '16px;',
        },
        formatter: function (value) {
          return `${value}°`;
        },
      },
    },
  };

  return (
    <Box $width={list.length * 44}>
      <Line data={data} options={options} />
    </Box>
  );
}

const Box = styled.div`
  width: ${({ $width }) => ($width ? `${$width}px` : 0)};
  height: 56px;
`;
